<script setup>

import { ref, inject } from 'vue';
import { TypeNommage } from '@/scripts/global.js';
import { 
    getErreurNomNorme,
    getErreurTexteRequis, 
    getErreurValeurListeRequise } from '@/scripts/controlesSaisie.js';
import { 
	apiAjouterConstante } from '@/services/ServiceModele.js';
import Dialog from 'primevue/dialog';
import Formulaire from '@/components/generiques/Formulaire.vue';
import SaisieTexte from '@/components/generiques/SaisieTexte.vue';
import SaisieTypeDonnee from '@/components/generiques/SaisieTypeDonnee.vue';

const getTypeDonnee = inject('getTypeDonnee');
const appelerApiModifModele = inject('appelerApiModifModele');

const emit = defineEmits(['fermeture']);

const { constante } = defineProps({
    constante: Object
});


const nouvelleConstante = ref(getConstanteInitiale());

function getConstanteInitiale() {
    return {
        nom: constante?.nom,
        typeDonnee: getTypeDonnee(constante?.typeDonnee),
        valeur: constante?.valeur
    };
}

function validerSaisie(constante) {
    const erreurs = {};
    erreurs.nom = getErreurNomNorme(constante.nom, TypeNommage.CONSTANTE);
    erreurs.typeDonnee = getErreurValeurListeRequise(constante.typeDonnee);
    erreurs.valeur = getErreurTexteRequis(constante.valeur);
    return erreurs;
}

function validerFormulaire() {
    nouvelleConstante.value.validationFormulaire = true;
}

function ajouterConstante() {
    appelerApiModifModele(apiAjouterConstante, nouvelleConstante.value, (reponseOK) => {
        if (reponseOK) {
            emit('fermeture');
        }
    });
}

function gererFermeture(visible) {
    if (!visible) {
        emit('fermeture');
    }
}

</script>

<template>
    <Dialog 
    :visible="true"
    :modal="true"
    @update:visible="gererFermeture">
        <template #header>
            <label class="titre">Ajout d'une constante</label>
        </template>
        <Formulaire
            :objet="nouvelleConstante"
            :fonction-validation-saisie="validerSaisie"
            @validation="ajouterConstante">
            <label class="intitule">Nom :</label>
            <SaisieTexte v-model:valeur="nouvelleConstante.nom" :id-erreur="'nom'" :autofocus="true" />
            <label class="intitule">Type :</label>
            <SaisieTypeDonnee 
                v-model:valeur="nouvelleConstante.typeDonnee" 
                :id-erreur="'typeDonnee'"
                :proposer-types-objets="false" />
            <label class="intitule">Valeur :</label>
            <SaisieTexte v-model:valeur="nouvelleConstante.valeur" :id-erreur="'valeur'" />
        </Formulaire>
        <template #footer>
            <button 
                class="bouton btn-primaire fas fa-check" 
                @click="validerFormulaire()"/>
        </template>
    </Dialog>
</template>

<style scoped>

.titre {
    margin-right: 10px;
}

</style>